import { ProgressBar } from "src/components/ProgressBar";
import { useElementSize } from "usehooks-ts";
import { SentencesList } from "./SentencesList";

export function ProgressMetric(props: {
  value: string;
  data?: any;
  tooltip?: any;
  lowerBetter?: boolean;
  higherBetter?: boolean;
  isPercent?: boolean;
}) {
  const isNa = props.value === undefined;
  const [sizeRef, { width }] = useElementSize();
  return (
    <div ref={sizeRef} style={{ position: "relative" }}>
      <div
        style={{
          textAlign: "right",
          height: 0,
          top: -25,
          position: "relative",
          fontWeight: isNa ? 400 : 600,
        }}
      >
        {isNa ? (
          "N/A"
        ) : (
          <>
            {props.value}
            {props.isPercent ? "%" : " / 10"}
          </>
        )}
      </div>
      <ProgressBar
        naComponent={<></>}
        key={props.value}
        type={props.higherBetter ? "higherBetter" : "lowerBetter"}
        value={props.value}
        tooltip={{
          mouseEnterDelay: 3,
          placement: "left",
          title: props.tooltip && <SentencesList data={props.tooltip} />,
        }}
        total={props.isPercent ? 100 : 10}
        showValue={false}
        progress={{ size: [width, 10] }}
      />
      {props.data && <SentencesList data={props.data} />}
    </div>
  );
}
